(function($){
    var getContainerForInput = function (elem) {
        var $container = $(elem).parents('.sq-form-question');
        return $container;
    };

    var options = {
        errorClass:     'sq-form-error',
        errorPlacement: function (error, element) {
            var $container = $(element).parents('.sq-form-question-answer');
            if ($(element).attr('id') === 'recaptcha_response_field') {
                error.insertAfter(element);
            }
            else {
                $container.append(error);
            }
        },

        // fn((element, errorClass, validClass))
        highlight: function (element) {
            getContainerForInput(element).addClass('sq-form-question-error');
        },

        // fn element, errorClass, validClass)
        unhighlight: function (element) {
            getContainerForInput(element).removeClass('sq-form-question-error');
        }
    };

    if(typeof $('.sq-form').get(0) !== 'undefined') {
        if ($('.sq-form').get(0).tagName !== 'DIV') {
            $('.sq-form').validate(options);
            console.log('sq-form validate fire');
        }
    }
}(jQuery));
